#version 300 es
precision mediump float;
in float vAlpha;
out vec4 fragColor;
void main() {
  // Soft circle: distance from center of point sprite
  vec2 center = gl_PointCoord - vec2(0.5);
  float dist = length(center) * 2.0;
  float alpha = vAlpha * smoothstep(1.0, 0.3, dist);
  if (alpha < 0.01) discard;
  // Smoke color: light gray
  fragColor = vec4(0.85, 0.85, 0.82, alpha);
}
